import { Injectable, OnDestroy } from '@angular/core';
import { IConvertor } from '../../../models/project/project-model';
import { IWorkspace, IWSInDTO } from '../../../models/workspace/workspace-model';
import { MissingArgumentsError } from '../../../models/errors/general.errors';
import { ProfileService } from '../../show/profile.service';

@Injectable()
export class WorkspaceConverterService implements IConvertor<IWSInDTO, IWorkspace, IWorkspace>, OnDestroy {
    constructor(private profileService: ProfileService) {}

    inToLocal(input: IWSInDTO): IWorkspace {
        if (!input) {
            throw new MissingArgumentsError(`Could not convert workspace to local because it's null`);
        }
        const email = this.profileService.user$.value?.email;
        const localWS: IWorkspace = {
            id: input.id,
            name: input.name,
            projectCount: input.projectCount,
            assetCount: input.assetCount,
            userCount: input.userCount,
            templateCount: input.templateCount,
            branding: input.branding,
            createdByEmail: input.createdByEmail,
            isWsOwner: input.createdByEmail === email,
            isMaster: input.isMaster,
        };
        return localWS;
    }

    localToOut(client: IWorkspace): IWorkspace {
        return client;
    }

    ngOnDestroy(): void {}
}
